exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-5b235359]{scroll-behavior:smooth}", ""]);

// exports
